import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../Context/GlobalContext";

export default function useCatalogue() {
  const { api, userID } = useContext(GlobalContext);

  const [catalogue, setCatalogue] = useState([]);
  const [variants, setVariants] = useState([]);
  const [printers, setPrinters] = useState([]);

  const [loading, setLoading] = useState(false);
  const [variantLoading, setVariantLoading] = useState(false);
  const [printerLoading, setPrinterLoading] = useState(false);
  const [rawInventory, setRawInventory] = useState([]);
  const [rawInventoryLoading, setRawInventoryLoading] = useState(false);

  const [subCategories, setSubCategories] = useState([]);
  const [subCategoryLoading, setSubCategoryLoading] = useState(false);
  const [sizeMaster, setSizeMaster] = useState([]);
  const [sizeMasterLoading, setSizeMasterLoading] = useState(false);
  const [uomMaster, setUomMaster] = useState([]);
  const [uomMasterLoading, setUomMasterLoading] = useState(false);
  /*  FETCH CATALOGUE */

  const fetchCatalogue = async () => {
    try {
      setLoading(true);

      // const res = await api.post("/Order/v1.0/getCatalogueItemsMaster", {
       const res = await api.post("/Order/v2.0/getCatalogueItemsMaster", {
         userid: userID,
         secret: "string",
       });

      if (res.data?.responseCode === "00") {
        setCatalogue(res.data.response || []);
        return res.data.response || [];
      } else {
        // toast.error("Failed to fetch catalogue");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching catalogue");
    } finally {
      setLoading(false);
    }
  };

  /* UPDATE STOCK / VISIBILITY */

  const updateItemStock = async (payload) => {
    try {
      const res = await api.post("/Order/v1.0/updateStock", payload);

      if (res.data?.responseCode === "00") {
        return res.data.responseMessage || "Updated successfully";
      } else {
        throw new Error(res.data.responseMessage);
      }
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  /* CHANGE AVAILABILITY */
  const changeAvailability = async (payload) => {
    try {
      const res = await api.post("/Order/v1.0/changeItemAvailability", payload);

      if (res.data?.responseCode === "00") {
        toast.success(res.data.responseMessage || "Updated successfully");
        return true;
      } else {
        toast.error(res.data.responseMessage);
        return false;
      }
    } catch (err) {
      console.error(err);
      toast.error("Error updating availability");
      return false;
    }
  };

  const updateVariantVisibility = async (payload) => {
    try {
      const res = await api.post("/Order/updateStocksAvailabilty", payload);

      if (res.data?.responseCode === "00") {
        // toast.success(res.data.responseMessage || "Updated successfully");
        return true;
      } else {
        toast.error(res.data.responseMessage);
        return false;
      }
    } catch (err) {
      console.error(err);
      toast.error("Error updating availability");
      return false;
    }
  };

  /*  UPDATE CUSTOMIZATION */

  const updateCustomization = async (payload) => {
    try {
      const res = await api.post("/Order/v1.0/updateCustomization", payload);

      if (res.data?.responseCode === "00") {
        toast.success("Customization updated");
        return true;
      } else {
        toast.error("Failed to update customization");
        return false;
      }
    } catch (err) {
      console.error(err);
      toast.error("Error updating customization");
      return false;
    }
  };

  /* PRINTER APIs */

  const assignPrinterToItem = async (payload) => {
    try {
      const res = await api.post("/Order/v1.0/addPrinterCodeToItem", payload);

      if (res.data?.responseCode === "00") {
        toast.success(res.data.responseMessage);
        return true;
      } else {
        toast.error(res.data.responseMessage);
        return false;
      }
    } catch (err) {
      console.error(err);
      toast.error("Error assigning printer");
      return false;
    }
  };

  /*  RESET STOCK */

  const resetStock = async () => {
    try {
      const res = await api.post("/Order/v1.0/resetStock", { userid: userID });

      if (res.data?.responseCode === "00") {
        toast.success(res.data.responseMessage);
        return true;
      } else {
        toast.error("Failed to reset stock");
        return false;
      }
    } catch (err) {
      console.error(err);
      toast.error("Error resetting stock");
      return false;
    }
  };

  const fetchRawInventory = async () => {
    try {
      setRawInventoryLoading(true);

      const res = await api.post("/Inventory/v2.0/getRawInventoryMaster", {});

      if (res.data?.responseCode === "00") {
        setRawInventory(res.data.response || []);
      } else {
        toast.error("Failed to fetch raw inventory");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching raw inventory");
    } finally {
      setRawInventoryLoading(false);
    }
  };

  const addRawInventoryMaster = async (itemName) => {
    try {
      const response = await api.post(
        "/Inventory/v2.0/InsertRawInventoryMaster",
        {
          itemName,
        },
      );

      return response.data;
    } catch (error) {
      console.error("Error adding raw inventory:", error);
      throw error;
    }
  };

  const addRecipeIngredient = async (payload) => {
    try {
      const res = await api.post(
        "/Inventory/v1.0/addRecipeIngredient",
        payload,
      );

      if (res.data?.responseCode === "00") {
        toast.success(
          res.data.responseMessage || "Ingredients added successfully",
        );
        return true;
      } else {
        toast.error(res.data.responseMessage);
        return false;
      }
    } catch (err) {
      console.error(err);
      toast.error("Error adding ingredients");
      return false;
    }
  };

  const syncInstamartItems = async (payload) => {
    try {
      const response = await api.post(
        "/Order/SyncCatalogItemInstamart",
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Sync API error:", error);
      throw error;
    }
  };

  const updateCategoryVisibility = async (payload) => {
    try {
      const res = await api.post("/Order/updateCategoryVisiblity", payload);

      if (res.data?.responseCode === "00") {
        toast.success(
          res.data.responseMessage || "Category visibility updated",
        );
        return true;
      } else {
        toast.error(
          res.data?.responseMessage || "Failed to update category visibility",
        );
        return false;
      }
    } catch (err) {
      console.error("Category visibility error:", err);
      toast.error("Error updating category visibility");
      return false;
    }
  };

  const extractChaafoMenuFromImage = async (file) => {
    try {
      if (!file) {
        toast.error("Please select image");
        return null;
      }

      setLoading(true);

      // Direct raw binary
      const binaryData = await file.arrayBuffer();

      const response = await api.post("/Chaafo/extract", binaryData, {
        headers: {
          "Content-Type": "application/octet-stream",
        },

        // Binary ko JSON/string me convert hone se rokega
        transformRequest: [(data) => data],
      });

      if (response?.data?.status === "completed") {
        return response.data;
      }

      toast.error(response?.data?.error || "Failed to extract image");
      return null;
    } catch (error) {
      console.error("EXTRACT CHAAFO MENU ERROR:", error);

      toast.error(
        error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Something went wrong while extracting image",
      );

      return null;
    } finally {
      setLoading(false);
    }
  };

  const fetchInventorySubCategories = async (categoryId = "0") => {
    try {
      setSubCategoryLoading(true);

      const res = await api.post("/Inventory/getInventorySubCategories", {
        category_id: String(categoryId || "0"),
      });

      if (res.data?.responseCode === "00") {
        const data = res.data?.response || res.data?.data || [];
        setSubCategories(data);
        return data;
      } else {
        toast.error(
          res.data?.responseMessage || "Failed to fetch sub categories",
        );
        return [];
      }
    } catch (err) {
      console.error("Sub category fetch error:", err);
      toast.error("Error fetching sub categories");
      return [];
    } finally {
      setSubCategoryLoading(false);
    }
  };

  const fetchSizeMaster = async (sizeType = "0") => {
    try {
      setSizeMasterLoading(true);

      const res = await api.post("/Inventory/sizeMasterGet", {
        size_type: String(sizeType || "0"),
      });

      if (res.data?.responseCode === "00") {
        const data = res.data?.response || res.data?.data || [];
        setSizeMaster(data);
        return data;
      } else {
        toast.error(res.data?.responseMessage || "Failed to fetch size master");
        return [];
      }
    } catch (err) {
      console.error("Size master fetch error:", err);
      toast.error("Error fetching size master");
      return [];
    } finally {
      setSizeMasterLoading(false);
    }
  };

  const fetchUomMaster = async (sizeType = "0") => {
    try {
      setUomMasterLoading(true);

      const res = await api.post("/Inventory/uomMasterGet", {
        size_type: String(sizeType || "0"),
      });

      if (res.data?.responseCode === "00") {
        const data = res.data?.response || res.data?.data || [];
        setUomMaster(data);
        return data;
      } else {
        toast.error(res.data?.responseMessage || "Failed to fetch UOM master");
        return [];
      }
    } catch (err) {
      console.error("UOM master fetch error:", err);
      toast.error("Error fetching UOM master");
      return [];
    } finally {
      setUomMasterLoading(false);
    }
  };

  return {
    userID,
    catalogue,
    variants,
    printers,
    loading,
    variantLoading,
    printerLoading,
    rawInventory,
    rawInventoryLoading,
    subCategories,
    subCategoryLoading,
    sizeMaster,
    sizeMasterLoading,
    uomMaster,
    uomMasterLoading,
    fetchCatalogue,
    updateItemStock,
    changeAvailability,
    updateVariantVisibility,
    updateCustomization,
    assignPrinterToItem,
    resetStock,
    fetchRawInventory,
    addRawInventoryMaster,
    addRecipeIngredient,
    syncInstamartItems,
    updateCategoryVisibility,
    extractChaafoMenuFromImage,
    fetchInventorySubCategories,
    fetchSizeMaster,
    fetchUomMaster,
  };
}
